import type { CSSProperties, ReactNode } from 'react';

export type BrandMarkProps = {
  /** Numeric font-size px or any CSS length (e.g. clamp(...)). */
  size?: number | string;
  /** Line-height (default 0.85 — ultra-tight). */
  lineHeight?: number | string;
  /** Override color (default `--color-orange-mark`). Use `'var(--color-ink)'` for the verdict subhead. */
  color?: string;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

/**
 * Italic Bricolage 800 wordmark with a baked-in orange marker bleed.
 * Used for the L'INFILTRÉ hero, BRIEFING / VOTE / VERDICT phase headers,
 * and the win-screen winner name. Color is overridable so the verdict
 * subhead can render in ink.
 */
export const BrandMark = ({
  size = 56,
  lineHeight = 0.85,
  color,
  className,
  style,
  children,
}: BrandMarkProps) => {
  return (
    <div
      className={['brand-mark', className ?? ''].filter(Boolean).join(' ')}
      style={{
        fontSize: size,
        lineHeight,
        ...(color ? { color } : null),
        ...(style ?? {}),
      }}
    >
      {children}
    </div>
  );
};
